import { useCallback, useState } from "react";
import { openManagedFile, type DownloadableFile } from "@/utils/managedFile";

/**
 * Click handler for attachment lists: fetches a link signed NOW and downloads it,
 * exposing which row is mid-flight so the caller can disable it / show a spinner.
 * See utils/managedFile.ts for why the `url` in the payload cannot be clicked.
 */
export function useManagedFileOpener() {
  const [busyId, setBusyId] = useState<string | null>(null);

  const openFile = useCallback(async (file: DownloadableFile) => {
    setBusyId(file.id);
    try {
      await openManagedFile(file);
    } finally {
      setBusyId(null);
    }
  }, []);

  return { openFile, busyId };
}
